/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Estes_Rebook_TitleInputs */

const en_orders_estes_rebook_title = /** @type {(inputs: Orders_Estes_Rebook_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rebook LTL Shipments?`)
};

const es_orders_estes_rebook_title = /** @type {(inputs: Orders_Estes_Rebook_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volver a reservar envios LTL?`)
};

/**
* | output |
* | --- |
* | "Rebook LTL Shipments?" |
*
* @param {Orders_Estes_Rebook_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_estes_rebook_title = /** @type {((inputs?: Orders_Estes_Rebook_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Estes_Rebook_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_estes_rebook_title(inputs)
	return es_orders_estes_rebook_title(inputs)
});